<h2 mat-dialog-title>Add New Attachment</h2>

<mat-dialog-content>
  <div class="file-upload-section">
    <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)">

    <!-- Drag & Drop Zone -->
    <div class="drop-zone"
         [class.drag-over]="isDragOver"
         [class.has-file]="selectedFile || currentAttachment.originalFileName"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">

      @if (isUploading) {
        <div class="uploading-state">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Uploading file...</p>
        </div>
      } @else if (selectedFile) {
        <div class="file-selected-state">
          <mat-icon class="file-icon">description</mat-icon>
          <p class="file-name">{{ selectedFile.name }}</p>
          <p class="file-size">{{ (selectedFile.size / 1024).toFixed(1) }} KB</p>
          <button mat-stroked-button (click)="clearSelection(); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
            Remove
          </button>
        </div>
      } @else if (currentAttachment.originalFileName) {
        <div class="file-selected-state">
          <mat-icon class="file-icon">description</mat-icon>
          <p class="file-name">{{ currentAttachment.originalFileName }}</p>
          <p class="file-hint">(existing file)</p>
        </div>
      } @else {
        <div class="empty-state" (click)="fileInput.click()">
          <mat-icon class="upload-icon">cloud_upload</mat-icon>
          <p class="drop-text">Drag & drop file here</p>
          <span class="or-text">or</span>
          <button mat-stroked-button color="primary" type="button">
            <mat-icon>folder_open</mat-icon>
            Browse Files
          </button>
        </div>
      }
    </div>
  </div>

  <form #attachmentForm="ngForm">
    <div class="attachment-form-grid">
      <mat-form-field appearance="fill">
        <mat-label>Attachment Number</mat-label>
        <input matInput [value]="currentAttachment.attachmentNum" readonly>
      </mat-form-field>

      @if (!primaryDocument) {
        <mat-form-field appearance="fill">
          <mat-label>Document Title</mat-label>
          <input
            matInput
            [(ngModel)]="currentAttachment.name"
            name="name"
            required
            placeholder="Document Title"
          >
        </mat-form-field>
      }

      <mat-form-field appearance="fill">
        <mat-label>Owner</mat-label>
        <input
          matInput
          type="text"
          [matAutocomplete]="auto"
          [(ngModel)]="currentAttachment.owner"
          (ngModelChange)="filterUsers($event)"
          name="owner"
          placeholder="Type last name of user"
        >
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          @for (user of filteredUsers; track user) {
            <mat-option [value]="user">{{ user.friendlyName }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      @if (!primaryDocument) {
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Description</mat-label>
          <textarea
            matInput
            [(ngModel)]="currentAttachment.description"
            name="description"
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      }

      @if (!primaryDocument) {
        <mat-form-field appearance="fill">
          <mat-label>Attachment Type</mat-label>
          <mat-select
            [(ngModel)]="currentAttachment.attachmentType"
            [disabled]="attachmentTypeReadOnly"
            name="attachmentType"
          >
            @for (attachmentType of allAttachmentTypes; track attachmentType) {
              <mat-option [value]="attachmentType">{{ attachmentType }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="!uploadComplete"
    (click)="onSaveAttachment()"
  >
    Save Attachment
  </button>
</mat-dialog-actions>